import {
    useEffect,
    useMemo, useState,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import FormWithControls from 'app/shared-components/FormWithControls'
import requests from 'app/requests/BillingCompany.requests'

import useGetBillingCompany from '../hooks/useGetBillingCompany'
import getFields from './abacus.fields'

const Abacus = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetBillingCompany(id)

    const [
        isSyncedWithAbacusDisabled,
        setIsSyncedWithAbacusDisabled,
    ] = useState<boolean>()

    useEffect(() => {
        setIsSyncedWithAbacusDisabled(data?.isSyncedWithAbacus)
    }, [data])

    const fields = useMemo(() => {
        return getFields({
            isSyncedWithAbacusDisabled,
            isNew: false,
        })
    }, [isSyncedWithAbacusDisabled])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name="AbacusTab"
                value={data}
                onSuccess={invalidate}
                fields={fields}
                requestParams={requests.abacus({
                    id,
                })}
                exists
            />
        </StatusHandler>
    )
}

export default Abacus
